export default __webpack_public_path__ + "static/media/worker15.82837a8e.jpeg";